import { InjectionToken } from '@angular/core';
import type { PermissionAction, PermissionScope } from '@mb/auth/shared';

/**
 * Abstraction over organization-scoped permission checks so feature modules
 * (e.g. contacts) can gate UX without importing `@modules/organization/client`.
 * Implemented by the workforce app via {@link OrganizationContextStore}.
 */
export interface ScopedAccessGate {
  can(entity: string, action: PermissionAction | string, minScope?: PermissionScope): boolean;
  selectedOrganizationId(): string | null;
}

export const SCOPED_ACCESS_GATE = new InjectionToken<ScopedAccessGate>(
  'SCOPED_ACCESS_GATE',
);
